<div class="input-field-cell">
  <label *ngIf="labelText" class="input-label">{{ labelText }}</label>

  <!-- Text input for regular fields -->
  <input
    *ngIf="inputType === 'text'"
    type="text"
    class="text-input"
    [(ngModel)]="inputValue"
    (ngModelChange)="onInputChange()"
    [placeholder]="placeholder || 'Enter value...'"
    [disabled]="isEditMode"
  />

  <!-- Dropdown for reference fields -->
  <select
    *ngIf="inputType === 'dropdown'"
    class="text-input"
    [(ngModel)]="inputValue"
    (ngModelChange)="onDropdownChange()"
    [disabled]="isEditMode || isLoadingOptions"
  >
    <option value="" disabled>{{ isLoadingOptions ? 'Loading options...' : (placeholder || 'Select an option...') }}</option>
    <option *ngFor="let option of dropdownOptions" [value]="option.value">
      {{ option.label }}
    </option>
  </select>

  <!-- Lookup input with ellipsis button -->
  <div *ngIf="inputType === 'lookup'" class="lookup-input-container">
    <input
      type="text"
      class="text-input lookup-input"
      [value]="lookupDisplayValue"
      readonly
      [placeholder]="placeholder || 'Click to select...'"
      (click)="openLookupDialog()"
    />
    <button
      type="button"
      class="lookup-button"
      (click)="openLookupDialog()"
      title="Open lookup"
    >
      <span class="lookup-icon">...</span>
    </button>
    <button
      *ngIf="lookupDisplayValue"
      type="button"
      class="clear-button"
      (click)="clearLookupValue()"
      title="Clear selection"
    >
      <span class="clear-icon">&times;</span>
    </button>
  </div>
</div>